module.exports = __webpack_public_path__ + "img/Sales_service_pic05.eeb5174c.jpeg";